/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Instructions_HintInputs */

const en_admin_resource_form_instructions_hint = /** @type {(inputs: Admin_Resource_Form_Instructions_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Will be emailed to visitors after booking is made.`)
};

const de_admin_resource_form_instructions_hint = /** @type {(inputs: Admin_Resource_Form_Instructions_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird den Besuchern nach der Buchung per E-Mail zugeschickt.`)
};

const es_admin_resource_form_instructions_hint = /** @type {(inputs: Admin_Resource_Form_Instructions_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se enviará por correo electrónico a los visitantes una vez efectuada la reserva.`)
};

const fr_admin_resource_form_instructions_hint = /** @type {(inputs: Admin_Resource_Form_Instructions_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les visiteurs recevront un courrier électronique une fois la réservation effectuée.`)
};

const nl_admin_resource_form_instructions_hint = /** @type {(inputs: Admin_Resource_Form_Instructions_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wordt per e-mail naar bezoekers gestuurd nadat de reservering is gemaakt.`)
};

/** @type {(inputs: Admin_Resource_Form_Instructions_HintInputs) => LocalizedString} */
const it_admin_resource_form_instructions_hint = en_admin_resource_form_instructions_hint;

/** @type {(inputs: Admin_Resource_Form_Instructions_HintInputs) => LocalizedString} */
const pt_br2_admin_resource_form_instructions_hint = en_admin_resource_form_instructions_hint;

/** @type {(inputs: Admin_Resource_Form_Instructions_HintInputs) => LocalizedString} */
const pl_admin_resource_form_instructions_hint = en_admin_resource_form_instructions_hint;

/** @type {(inputs: Admin_Resource_Form_Instructions_HintInputs) => LocalizedString} */
const hu_admin_resource_form_instructions_hint = en_admin_resource_form_instructions_hint;

/** @type {(inputs: Admin_Resource_Form_Instructions_HintInputs) => LocalizedString} */
const ro_admin_resource_form_instructions_hint = en_admin_resource_form_instructions_hint;

/**
* | output |
* | --- |
* | "Will be emailed to visitors after booking is made." |
*
* @param {Admin_Resource_Form_Instructions_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_instructions_hint = /** @type {((inputs?: Admin_Resource_Form_Instructions_HintInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Instructions_HintInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_instructions_hint(inputs)
	if (locale === "de") return de_admin_resource_form_instructions_hint(inputs)
	if (locale === "es") return es_admin_resource_form_instructions_hint(inputs)
	if (locale === "fr") return fr_admin_resource_form_instructions_hint(inputs)
	if (locale === "nl") return nl_admin_resource_form_instructions_hint(inputs)
	if (locale === "it") return it_admin_resource_form_instructions_hint(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_instructions_hint(inputs)
	if (locale === "pl") return pl_admin_resource_form_instructions_hint(inputs)
	if (locale === "hu") return hu_admin_resource_form_instructions_hint(inputs)
	return ro_admin_resource_form_instructions_hint(inputs)
});
export { admin_resource_form_instructions_hint as "admin.resource_form.instructions_hint" }